module.exports = __webpack_public_path__ + "static/cables-4929f89ab070ff04112cb34fee348497.jpeg";